<template>
  <span />
</template>

<script lang="ts">
import Vue from 'vue';
import {
  Component, Inject, Watch, Prop,
} from 'vue-property-decorator';
import { mapState } from 'vuex';
import { Alert, NoticeClass, AuthStore } from '@kasasa/fbase-components/lib';
import { ReportResource } from '@/api/reports/ReportResource';
import { Cycle } from '@/api/cycles';

@Component({
  computed: mapState(['fiId']),
})
export default class ReportDownloader extends Vue {
  fiId!: string;

  @Prop() cycle!: Cycle;

  @Prop() value!: string | null;

  @Inject('ReportResource')
  reportResource!: ReportResource;

  @Watch('value')
  async downloadReport() {
    if (this.cycle && this.value && this.value.length > 0) {
      await this.reportResource.downloadReport(this.fiId, this.cycle.id, this.value).then((reportContent: Blob) => {
        this.downloadReportContent(reportContent);
      }).catch((error) => {
        this.showErrorMessage(error);
      }).finally(() => {
        this.$emit('input', null);
      });
    }
  }

  downloadReportContent(content: Blob) {
    if (this.value) {
      const anchor = document.createElement('a');
      anchor.href = URL.createObjectURL(content);
      anchor.download = this.value;
      anchor.click();
    }
  }

  showErrorMessage(error: string) {
    const al = new Alert(error, NoticeClass.ERROR);
    al.setTimeout(5000);
    this.$store.dispatch('notices/add', al);
  }
}
</script>
<style lang="scss">
</style>
